import { createSelector } from "@reduxjs/toolkit";
import { IState } from "../..";
import { UserRole } from "../../../util/user";
import { PATH_NAME, paths } from "../Navigation/reducer";

const UserState = (state: IState) => state.user

export const selectUserDetails = createSelector(UserState, (state) => state.details);
export const selectUserLoading = createSelector(UserState, (state) => state.loading);
export const selectIsAdmin = createSelector(UserState, (state) => state.details?.role === UserRole.ADMIN);
export const selectNavigation = createSelector(UserState, (state) => {
  const { role } = state.details || {};
  if (role === UserRole.ADMIN) {
    return paths;
  }

  if (role === UserRole.REVIEWER) {
    const reviewerPaths = [
      PATH_NAME.NOT_FOUND,
      PATH_NAME.HOME,
      PATH_NAME.SURVEYS,
      PATH_NAME.SURVEY_VIEW,
      PATH_NAME.USER_VIEW,
  ]
    return paths.filter(({ label }) => reviewerPaths.includes(label));
  }

  const defaultPaths = [PATH_NAME.NOT_FOUND, PATH_NAME.HOME];
  return paths.filter(({ label }) => defaultPaths.includes(label));
}); 